import { inject, Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class MatPaginatorTranslatedComponent extends MatPaginatorIntl {
  private translateService = inject(TranslateService);

  itemsPerPageLabel = 'Elemente pro Seite';

  firstPageLabel = this.translateService.instant('campaign.overview.paginatorFirstPageLabel');

  previousPageLabel = this.translateService.instant('campaign.overview.paginatorPreviousPageLabel');

  nextPageLabel = this.translateService.instant('campaign.overview.paginatorNextPageLabel');

  lastPageLabel = this.translateService.instant('campaign.overview.paginatorLastPageLabel');

  getRangeLabel = (page: number, pageSize: number, _length: number): string => {
    let length: number = _length;
    if (length === 0 || pageSize === 0) {
      return `0 ${this.translateService.instant('campaign.overview.paginatorRangeLabelDelimiter')} ${length}`;
    }
    length = Math.max(length, 0);
    const startIndex = page * pageSize;
    const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
    return `${startIndex + 1} - ${endIndex} ${this.translateService.instant(
      'campaign.overview.paginatorRangeLabelDelimiter',
    )} ${length}`;
  };
}
